import axiosClient from "api/axios_client.js";

const apiCountryDirectory = {
  create: (payload) => axiosClient.post(`/directories/business-master/country-directory/create`, payload),
  update: (id, payload) => axiosClient.put(`/directories/business-master/country-directory/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/directories/business-master/country-directory/get-by-id/${id}`),
  updateStatus: (payload) => axiosClient.post(`/directories/business-master/country-directory/update-status`, payload),
  getAllCountry: (payload) => axiosClient.post(`/directories/business-master/country-directory/get-all`, payload),
  delete: (ids) => axiosClient.delete(`/directories/business-master/country-directory/delete`, { data: { ids } }),
};

export default apiCountryDirectory;
